import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import ProjectCard from "./ProjectCards";
import BlogCard from "./BlogsCards";
import Particle from "../Particle";
import "../../style.css";
import "bootstrap/dist/css/bootstrap.min.css";

import online from "../../Assets/Projects/online.jpg";
import innovatejo from "../../Assets/Projects/innovatejo.png";
import computergy from "../../Assets/Projects/computergy.png";
// import editor from "../../Assets/Projects/codeEditor.png";
// import eeg from "../../Assets/Projects/eeg.gif";
// import suicide from "../../Assets/Projects/suicide.png";
// import algo from "../../Assets/Projects/algo.png";
// import plant from "../../Assets/Projects/plant.jpeg";

function Projects() {
  return (
    <Container fluid className="project-section">
      <Particle />
      <Container>
        <h1 className="project-heading">
          My Recent <strong className="purple">Works </strong>
        </h1>
        <p style={{ color: "white" }}>
          Here are a few projects I've worked on recently.
        </p>
        <Row style={{ justifyContent: "center", paddingBottom: "10px" }}>
          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={online}
              isBlog={false}
              title="Online Store"
              description="Working on making things a bit easier for traders around the world instead of them having the effort of heading to empty stores and starting there buisness that way, i cam up with an idea of turning all there products into a virtual producats where they dont have to exist so they can seel there products."
              link="https://github.com/rakad-dwairi/Online-Store"
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={innovatejo}
              isBlog={false}
              title="InnovateJo"
              description="InnovateJo is a virtual company which consists of a talented team, designers and programmers where iu managed to build and work hard on and hopefully it will be with new for technology and artifical intelligince."
              link="https://innovatejo.netlify.app/"
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={computergy}
              isBlog={false}
              title="Computergy Team"
              description="Built a web site for our team which i was elicted to be a leader for it, and conducted a team which  moved forward to be one of the greatest teams of the IT Department"
              link="http://computergy.glitch.me/?fbclid=IwAR3h3tvCIoe2tpW_9Jz--7GVohs_P8ekMy3HrpPYH-goP1cJJB4LWxSRI6k"
            />
          </Col>

          {/* <Col md={4} className="project-card">
            <ProjectCard
              imgPath={emotion}
              isBlog={false}
              title="Small CV"
              description="Trained a CNN classifier using 'FER-2013 dataset' with Keras and tensorflow backened. The classifier sucessfully predicted the various types of emotions of human. And the highest accuracy obtained with the model was 60.1%.
              Then used Open-CV to detect the face in an image and then pass the face to the classifer to predict the emotion of a person."
              link="https://rakad-dwairi.github.io/cv/"
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={eeg}
              isBlog={false}
              title="Emotion Predcition from EEG Signals"
              description="Using EEG signals from 'AMIGOS' Dataset to extract features and train a classifier that helps in detection of human emotions from Brain Signals."
              link="https://gist.github.com/soumyajit4419/dc94177bc4954752051798f88fbce1df"
            />
          </Col> */}
        </Row>
        {/* <h1 className="project-heading">
          My Recent <strong className="purple">Blog </strong> Posts
        </h1>
        <p style={{ color: "white" }}>Do give a read to some of my blogs</p>
        <Row style={{ justifyContent: "center" }}>
          <Col md={4} className="blog-card">
            <BlogCard
              imgPath={algo}
              link=""
              title="Cracking Interview"
              site="gitbook.com"
            />
          </Col>
          <Col md={4} className="blog-card">
            <BlogCard
              imgPath={plant}
              link="https://medium.com/jovianml/plant-ai-c8fc95ed90e6"
              title="Plant AI"
              site="medium.com"
            />
          </Col>
        </Row> */}
      </Container>
    </Container>
  );
}

export default Projects;
